window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    function toggleDropdown() {
      $(this).closest('[data-dropdown]').toggleClass('open');
    }

    function onOptionChange(e) {
      e.preventDefault();

      let $item = $(this);
      let input = $item.closest('[data-dropdown]').find('input');
      let valueElem = $item.find('[data-search-term]');
      let label = valueElem.text().trim();

      if (!label) {
        console.error('No label found');
        return;
      }

      let value =
        valueElem.data('search-term') ||
        label.toLowerCase().replace(/\s/g, '-');

      if (!value) {
        console.error('No value or label found');
        return;
      }

      input.val(value);
      $item
        .closest('[data-dropdown]')
        .find('[data-dropdown-label]')
        .text(label);

      toggleDropdown.apply(this);
    }

    $('[data-dropdown] [data-dropdown-trigger]')
      .off('click', toggleDropdown)
      .on('click', toggleDropdown);
    $('[data-dropdown] [data-dropdown-item]')
      .off('click', onOptionChange)
      .on('click', onOptionChange);
  });
});
